<template>
<div>
    <!-- <v-toolbar color="white" flat>
        <v-spacer></v-spacer>
        <v-checkbox label="Show Weekend" v-model="showWeekend"></v-checkbox>
        <v-checkbox label="Show System Tickets" v-model="showSystemTickets"></v-checkbox>
    </v-toolbar> -->
    <!-- <v-toolbar flat><v-spacer></v-spacer>
        <v-toolbar-title>Calendar</v-toolbar-title>
    <v-spacer></v-spacer>
    </v-toolbar> -->
    <v-toolbar flat>
        <v-icon @click="subtractWeek()">chevron_left</v-icon>
        <v-spacer></v-spacer>
        <v-layout align-center justify-center>
            <h2 @click="modal=true" style="cursor: pointer">{{formatDate(date)}}</h2>
            <v-btn icon style="margin-right: 0" @click="addNewTicket(new Date())">
                <v-icon color="primary">add_circle_outline</v-icon>
            </v-btn>
         

            <v-menu bottom offset-y right :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon style="margin: 0">
                        <v-icon color="grey">filter_alt</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-tile>
                        <v-list-tile-action>
                            <v-checkbox v-model="showSystemTickets"></v-checkbox>
                        </v-list-tile-action>
                        <v-list-tile-title>Show System Tickets</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile>
                        <v-list-tile-action>
                            <v-checkbox v-model="showWeekend"></v-checkbox>
                        </v-list-tile-action>
                        <v-list-tile-title>Show Weekends</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile>
                        <v-list-tile-action>
                            <v-checkbox v-model="showCompleted"></v-checkbox>
                        </v-list-tile-action>
                        <v-list-tile-title>Show Completed Tickets</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>

            <v-menu bottom offset-y right :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon style="margin: 0">
                        <v-icon color="grey">event</v-icon>
                    </v-btn>
                </template>

                <v-list style="overflow-y: auto; max-height: 500px">
                    <v-subheader>
                        <v-checkbox v-model="selectAllUserRoles" @change="changeAllUserRoles()" label="Select All User Roles"></v-checkbox>
                       
                    </v-subheader>
                    <v-divider></v-divider>
                    <v-list-tile v-for="role in userRoles" :key="role.id">
                        <v-list-tile-action>
                            <v-checkbox v-model="role.selected" @change="refreshFilteredTickets()"></v-checkbox>
                        </v-list-tile-action>
                        <v-list-tile-title>{{role.name}}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <!-- <v-menu bottom offset-y right :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon style="margin: 0">
                        <v-icon color="grey">person</v-icon>
                    </v-btn>
                </template>

                <v-list style="overflow-y: auto; max-height: 500px">
                    <v-subheader>
                        <v-checkbox v-model="selectAllUsers" @change="changeAllUsers()"></v-checkbox> Users
                    </v-subheader>
                    <v-text-field style="padding: 10px" label="Search" v-model="searchUsers"></v-text-field>
                    <v-list-tile v-for="user in filteredOrganisationUsers" :key="user.id">
                        <v-list-tile-action>
                            <v-checkbox v-model="user.selected" @change="refreshFilteredTickets()"></v-checkbox>
                        </v-list-tile-action>
                        <v-list-tile-title>{{user.fullname}}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu> -->

        </v-layout>
        <v-spacer></v-spacer>
        <v-icon @click="addWeek()">chevron_right</v-icon>
    </v-toolbar>
    <v-layout justify-center>
        <v-flex v-for="day in filteredDays" :key="day" style="border: 1px solid grey; max-width: 250px" auto class="px-0">
            <v-flex class="text-xs-center" style="border-bottom: 1px solid grey">
                <v-btn round :color="isToday(day.date)?'light-blue':'grey'" class="white--text" style="cursor: pointer" @click="addNewTicket(day.date)">{{day.date.getDate()}}</v-btn>
                <br>
                {{formatWeekDate(day.date)}} <br>
                <!-- <span style="fontSize: 12px;">{{day.tickets.length}} items</span> -->
            </v-flex>
            <v-list two-line class="ma-0 pa-0" style="cursor: pointer">
                <draggable v-model="day.openTickets" :options='{group: "tickets"}' @change="change">
                    <template v-for="(ticket) in day.openTickets">
                        <v-list-tile avatar :key="ticket.id" hover :style="{'fontSize': '12px', 'border-bottom': '1px solid lightgrey', 'border-left': '5px solid ' + getStatusColor(ticket)}" @click="editTicket(ticket)">
                            <v-list-tile-content>
                                <v-list-tile-title v-if="!ticket.name" style="fontSize: 12px;text-overflow: ellipsis;overflow: hidden;" class="text-wrap">
                                    {{ticket.id}}:{{ticket.ticketCategoryItem?ticket.ticketCategoryItem.name:''}}

                                </v-list-tile-title>
                                <v-list-tile-title v-else style="fontSize: 12px;text-overflow: ellipsis;overflow: hidden;" class="text-wrap" v-html="ticket.name"></v-list-tile-title>
                                <v-list-tile-sub-title v-if="ticket.location" style="fontSize: 12px;text-overflow: ellipsis;overflow: hidden;">
                                    {{ticket.location.locationDescription}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title v-if="ticket.location" style="fontSize: 12px;text-overflow: ellipsis;overflow: hidden;">
                                    <span v-if="ticket.location&&ticket.location.locationNetwork">
                                        {{ticket.location.locationNetwork.name}}
                                    </span>
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title v-else-if="ticket.locationNetwork" style="fontSize: 12px;text-overflow: ellipsis;overflow: hidden;">
                                    <span>
                                        {{ticket.locationNetwork.name}}
                                    </span>
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title v-else-if="ticket.locationNode" style="fontSize: 12px;text-overflow: ellipsis;overflow: hidden;">
                                    <span>
                                        {{ticket.locationNode.name}}
                                    </span>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action v-if="ticket.dueTime||ticket.isComplete||ticket.assignedTo" style="fontSize: 12px">
                                <v-tooltip top v-if="ticket.assignedTo">
                                    <template v-slot:activator="{ on }">
                                        <v-avatar v-on="on" size="23px" color="blue" class="title white--text" v-if="
                              ticket.assignedTo
                            ">
                                            <span class="smallText" v-if="ticket.assignedTo">{{ ticket.assignedTo.name.charAt(0)
                              }}{{
                                ticket.assignedTo.surname.charAt(0)
                              }}</span>
                                        </v-avatar>
                                    </template>
                                    <span  v-if="ticket.assignedTo">{{ ticket.assignedTo.name
                              }} {{
                                ticket.assignedTo.surname
                              }}</span>
                                </v-tooltip>
                                <span v-if="!ticket.isComplete&&ticket.dueTime">{{formatTime(ticket.dueTime)}}</span>
                                <v-icon v-else-if="ticket.isComplete" color="green">check_circle_outline</v-icon>
                            </v-list-tile-action>
                        </v-list-tile>
                    </template>
                </draggable>
                <v-subheader v-if="day.completeTickets&&day.completeTickets.length>0" style="background: #ededed">
                    <h4 style="color: black">Complete Tickets</h4>
                    <v-spacer></v-spacer>
                    <v-chip>{{day.completeTickets.length}}</v-chip>
                </v-subheader>
                <v-list-tile v-for="complete in day.completeTickets" avatar :key="complete.id" hover :style="{'fontSize': '12px', 'border-bottom': '1px solid lightgrey', 'border-left': '5px solid ' + getStatusColor(complete)}" @click="editTicket(complete)">
                    <v-list-tile-content>
                        <v-list-tile-title v-if="!complete.name" style="fontSize: 12px;text-overflow: ellipsis;overflow: hidden;" class="text-wrap" v-text="complete.id +': '+complete.ticketCategoryItem.name">
                        </v-list-tile-title>
                        <v-list-tile-title v-else style="fontSize: 12px;text-overflow: ellipsis;overflow: hidden;" class="text-wrap" v-html="complete.name"></v-list-tile-title>
                        <v-list-tile-sub-title v-if="complete.location" style="fontSize: 12px;text-overflow: ellipsis;overflow: hidden;">
                            {{complete.location.locationDescription}}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title style="fontSize: 12px;text-overflow: ellipsis;overflow: hidden;">
                            <span v-if="complete.location&&complete.location.locationNetwork">
                                {{complete.location.locationNetwork.name}}
                            </span>
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action v-if="complete.dueTime||complete.isComplete||complete.assignedTo" style="fontSize: 12px">
                        <v-tooltip top v-if="complete.assignedTo">
                            <template v-slot:activator="{ on }">
                                <v-avatar v-on="on" size="23px" color="blue" class="title white--text" v-if="
                              complete.assignedTo
                            ">
                                    <span class="smallText"  v-if="complete.assignedTo">{{ complete.assignedTo.name.charAt(0)
                              }}{{
                                complete.assignedTo.surname.charAt(0)
                              }}</span>
                                </v-avatar>
                            </template>
                            <span  v-if="complete.assignedTo">{{ complete.assignedTo.name
                              }} {{
                                complete.assignedTo.surname
                              }}</span>
                        </v-tooltip>

                        <span v-if="!complete.isComplete">{{formatTime(complete.dueTime)}}</span>
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>
        </v-flex>
    </v-layout>

    <v-dialog ref="dialog" v-model="modal" lazy full-width width="750px">
        <v-date-picker style="height: 350px" landscape full-width scrollable v-model="pickerDate">
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="modal=false">OK</v-btn>
        </v-date-picker>

    </v-dialog>

    <v-dialog v-model="viewTicket" width="1200px" persistent>
        <v-card>
            <TicketSummaryModal :ticket="ticket" @close="viewTicket=false, ticket={}" @ticketCreated="viewTicket=false,refreshTickets()" :key="ticketKey" />
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import Api from "@/services/Api.js";
import dateformat from "dateformat";
import draggable from "vuedraggable";
import TicketSummaryModal from '../components/TicketSummaryModal.vue'

export default {
    components: {
        draggable,
        TicketSummaryModal
    },
    data() {
        return {
            allTickets: [],
            showAllCalendar: true,
            userRoleFilter: [],
            userFilter: [],
            pickerDate: new Date().toISOString().substr(0, 10),
            date: new Date(),
            days: [],
            modal: false,
            organisationUsers: [],
            refreshKey: 0,
            showCompleted: true,
            showWeekend: true,
            showSystemTickets: true,
            selectAllUsers: true,
            selectAllUserRoles: true,
            searchUsers: '',
            ticket: {},
            ticketKey: 0,
            userRoles: [],
            viewTicket: false
        }
    },
    computed: {
        filteredTickets() {
            let result = this.allTickets
            if (!this.showSystemTickets) {
                result = result.filter(x => !x.isSystemGenerated)
            }
            if (!this.showCompleted) {
                result = result.filter(x => !x.isComplete)
            }

            //  if(!this.selectAllUsers){
            //      let selectedUsers = this.organisationUsers.filter(x=>x.selected)
            //     result = result.filter(x=>selectedUsers.map(y=>y.id).includes(x.assignedToId))
            // }
            if (!this.selectAllUserRoles) {
                let selectedRoles = this.userRoles.filter(x => x.selected).map(x => x.id)
                result = result.filter(x => selectedRoles.includes(x.userRoleId))
            }

            // if (!this.selectAllUsers) {
            //     let selectedUsers = this.organisationUsers.filter(x => x.selected).map(x => x.id)
            //     result = result.filter(x => selectedUsers.includes(x.assignedToId))
            // }

            return result
        },
        filteredDays() {
            let result = this.days
            if (!this.showWeekend) {
                result = result.slice(1, 6)
            }
            // console.log(result)
            return result
        },
        filteredOrganisationUsers() {
            let result = this.organisationUsers
            if (this.searchUsers) {
                result = result.filter(x => x.fullname.toLowerCase().includes(this.searchUsers.toLowerCase()))
            }
            return result
        }
    },
    watch: {
        showSystemTickets(value) {
            this.refreshFilteredTickets()
        },
        showCompleted(value) {
            this.refreshFilteredTickets()
        },
        pickerDate(value) {
            if (value) {
                this.date = new Date(value)
            }
        },
        async date(value) {
            if (value) {
                this.days = this.generateWeekdays()
                this.refreshTickets()
            }
        }
    },
    created() {
        this.date = new Date()
        this.days = this.generateWeekdays()
        this.fetchOrgContacts()
        this.fetchUserRoles()
    },
    methods: {
        async change(event) {
            let keys = Object.keys(event)
            if (keys.includes('added')) {
                let day = this.days.find(x => x.openTickets.map(y => y.id).includes(event.added.element.id))
                day.openTickets[event.added.newIndex].dueDate = day.date
                await this.updateTicketDate({
                    id: event.added.element.id,
                    dueDate: day.date
                })
            }
        },
        addWeek() {
            this.date.setDate(this.date.getDate() + 7)
            this.pickerDate = this.date.toISOString().substr(0, 10)
        },
        fetchOrgContacts() {
            this.organisationUsers = [];
            Api()
                .get("/organisationContact")
                .then(async (response) => {
                    let contactArray = await response.data.map((x) => x.contact);
                    this.organisationUsers = contactArray.map(x => ({
                        id: x.id,
                        fullname: x.name + ' ' + x.surname,
                        name: x.name,
                        surname: x.surname,
                        email: x.email,
                        mobileNumber: x.mobileNumber
                    }))
                });
        },
        changeAllUserRoles() {
            if (this.selectAllUserRoles) {
                this.userRoles.forEach(x => x.selected = true)
            } else {
                this.userRoles.forEach(x => x.selected = false)
            }
            this.refreshFilteredTickets()
        },
        changeAllUsers() {
            if (this.selectAllUsers) {
                this.organisationUsers.forEach(x => x.selected = true)
            } else {
                this.organisationUsers.forEach(x => x.selected = false)
            }
            this.refreshFilteredTickets()
        },
        fetchUserRoles() {
            Api()
                .get("/userRole")
                .then((response) => {
                    response.data.forEach(x => x.selected = true)
                    this.userRoles = response.data;
                });
        },
        getStatusColor(ticket) {
            switch (ticket.currentStatus) {
                case 'Complete':
                    return '#119c36'
                case 'Incomplete':
                    return 'red'
                case 'Pending':
                    return 'orange'
                case 'In Progress':
                    return 'lightblue'
                case 'Canceled':
                    return 'red'
            }
        },
        subtractWeek() {
            this.date.setDate(this.date.getDate() - 7)
            this.pickerDate = this.date.toISOString().substr(0, 10)
        },
        addNewTicket(date) {
            this.ticket = {
                currentStatus: 'Pending',
                importance: 'Average',
                dueDate: date,
                documents: []
            }
            this.viewTicket = true
        },
        async editTicket(item) {
            this.$router.push({
                path: "/ticketSummary/" + item.id
            });
        },
        async fetchTicketComments(id) {
            let result = []
            await Api()
                .get("/allTicketComment/byTicket/" + id)
                .then(async (response) => {
                    result = response.data.map(x => ({
                        commentedById: x.commentedById,
                        commentedByName: x.commentedBy.name,
                        commentedBySurname: x.commentedBy.surname,
                        comment: x.comment,
                        type: x.type,
                        createdAt: x.createdAt,
                        id: x.id,
                        commentLogType: true
                    }))
                })
            return result
        },
        async fetchTicketAssignments(id) {
            let result = []
            await Api()
                .get("/ticketAssignLog/byTicket/" + id)
                .then(async (response) => {
                    result = response.data.map((x) => ({
                        assignedById: x.assignedById,
                        assignedByName: x.assignedBy.name,
                        assignedBySurname: x.assignedBy.surname,
                        assignedToId: x.assignedToId,
                        assignedToName: x.assignedTo.name,
                        assignedToSurname: x.assignedTo.surname,
                        createdAt: x.createdAt,
                        id: x.id,
                        commentLogType: false,
                    }))
                });
            return result
        },
        async fetchTicketJobHours(id) {
            let result = []
            await Api()
                .get("/ticketJobHours/byTicket/" + id)
                .then(async (response) => {
                    result = response.data.map(x => ({
                        contactId: x.contactId,
                        contactName: x.contact.name,
                        contactSurname: x.contact.surname,
                        startDate: x.startDate,
                        stoppedDate: x.stoppedDate,
                        createdAt: x.startDate,
                        id: x.id,
                        hoursLogType: true,
                    }))
                });
            return result
        },

        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "mmmm yyyy");
            } else {
                null;
            }
        },
        formatDay(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd");
            } else {
                null;
            }
        },
        formatWeekDate(date) {
            if (date !== null) {
                return dateformat(date, "ddd");
            } else {
                null;
            }
        },
        formatTime(time) {
            let split = time.split(':')
            return split[0] + ':' + split[1]
        },
        getDaysTickets(day) {
            let result = this.filteredTickets.filter(x => x.dueDate == this.formatDay(day))
            let incomplete = result.filter(x => !x.isComplete)
            let complete = result.filter(x => x.isComplete)
            return [...incomplete, ...complete]
        },
        generateWeekdays() {
            let val = new Date(this.date)
            var week = new Array();
            // Starting Monday not Sunday
            val.setDate((val.getDate() - val.getDay()));
            for (var i = 0; i < 7; i++) {
                week.push(
                    new Date(val)
                );
                val.setDate(val.getDate() + 1);
            }
            week = week.map(x => ({
                date: x,
                tickets: [],
                openTickets: [],
                completeTickets: []
            }))
            return week;
        },
        async getTickets(start, end) {
            let result = []
            await Api()
                .get("/ticket/week/" + start + "/" + end)
                .then(async (response) => {
                    result = response.data
                    this.refreshKey ++
                });
            return result
        },
        async refreshTickets() {
            this.allTickets = await this.getTickets(this.formatDay(this.days[0].date), this.formatDay(this.days[this.days.length - 1].date))
            this.days = this.days.map(x => ({
                date: x.date,
                tickets: this.getDaysTickets(x.date),
                completeTickets: this.getDaysTickets(x.date).filter(x => x.isComplete),
                openTickets: this.getDaysTickets(x.date).filter(x => !x.isComplete)
            }))
        },
        refreshFilteredTickets() {
            if (this.userRoles.filter(x => x.selected).length != this.userRoles.length) {
                this.selectAllUserRoles = false
            } else {
                this.selectAllUserRoles = true
            }
            if (this.organisationUsers.filter(x => x.selected).length != this.organisationUsers.length) {
                this.selectAllUsers = false
            } else {
                this.selectAllUsers = true
            }
            this.days = this.days.map(x => ({
                date: x.date,
                tickets: this.getDaysTickets(x.date),
                completeTickets: this.getDaysTickets(x.date).filter(x => x.isComplete),
                openTickets: this.getDaysTickets(x.date).filter(x => !x.isComplete)
            }))
        },
        isToday(date) {
            let today = new Date()
            return date.getDate() == today.getDate() && date.getMonth() == today.getMonth() && date.getFullYear() == today.getFullYear()
        },
        async updateTicketDate(obj) {
            console.log(obj)
            await Api().put('/ticket/' + obj.id, obj)
        },
        updateTicketData(data) {
            this.ticket = data
            this.ticketKey++
        }
    }
}
</script>

<style scoped>
.wrap-text {
    /* -webkit-line-clamp: unset !important; */
    white-space: normal;
}
</style>
